import { render, staticRenderFns } from "./StageFrame.vue?vue&type=template&id=6442bd23&scoped=true&"
import script from "./StageFrame.vue?vue&type=script&lang=js&"
export * from "./StageFrame.vue?vue&type=script&lang=js&"
import style0 from "./StageFrame.vue?vue&type=style&index=0&id=6442bd23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442bd23",
  null
  
)

export default component.exports